import React from "react";
import { inject } from "mobx-react";
import classNames from "classnames";
import { Link } from "react-router-dom";

@inject("user")
export default class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div className="information unified">
        <div className={classNames({ logged_user: this.props.user.getUser() })}>
          <div className="about-us-container newpages">
            <div className="logo">
              <svg
                version="1.1"
                id="Слой_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 760.8 158"
                style={{ enableBackground: "new 0 0 760.8 158" }}
              >
                <g>
                  <path
                    className="st0"
                    d="M283.7,78.9c0-10.9-2.1-21.1-6.2-30.7c-4.2-9.6-9.8-17.9-17-25c-7.2-7.1-15.6-12.7-25.2-16.9
		C225.5,2.1,215.3,0,204.4,0c-2.8,0-5.5,0.1-8.1,0.4H0v37.3l52.6-0.5h10.9V158H104V37.2h33.1c-2.2,3.4-4.1,7.1-5.7,10.9
		c-4.2,9.6-6.2,19.8-6.2,30.7c0,10.9,2.1,21.1,6.2,30.7c4.2,9.6,9.8,17.9,17,25s15.5,12.7,25.1,16.8c9.6,4.1,19.9,6.1,30.9,6.1h79.3
		V78.9L283.7,78.9z M188.8,116.4c-4.8-2.2-8.9-5.2-12.4-8.9c-3.5-3.7-6.2-8.1-8.2-13.1c-2-5-3-10.2-3-15.5c0-5.5,1-10.7,3-15.6
		c2-4.9,4.7-9.2,8.2-13c3.5-3.7,7.6-6.7,12.4-8.9c4.8-2.2,10-3.4,15.6-3.4c5.6,0,10.8,1.1,15.6,3.4c4.8,2.2,8.9,5.2,12.4,8.9
		c3.5,3.7,6.2,8,8.2,13c2,4.9,3,10.1,3,15.6c0,5.4-1,10.6-3,15.5c-2,5-4.7,9.3-8.2,13.1c-3.5,3.7-7.6,6.7-12.4,8.9
		c-4.8,2.2-10,3.4-15.6,3.4C198.8,119.8,193.6,118.6,188.8,116.4z"
                  />
                  <path
                    className="st1"
                    d="M375,24.5h-16.4v45.4H352V24.5h-16.3V19H375V24.5z"
                  />
                  <path
                    className="st1"
                    d="M428.8,69.9h-6.7V46.4h-25.7v23.5h-6.7V19h6.7v21.9h25.7V19h6.7V69.9z"
                  />
                  <path
                    className="st1"
                    d="M476.7,46.4h-22.1v18h25.6v5.5h-32.3V19h32v5.5h-25.3v16.4h22.1V46.4z"
                  />
                  <path
                    className="st1"
                    d="M514.4,49.3h-12v20.6h-6.7V19h16.9c5.7,0,10.1,1.3,13.2,3.9c3.1,2.6,4.6,6.4,4.6,11.4c0,3.2-0.9,5.9-2.6,8.3
		c-1.7,2.4-4.1,4.1-7.1,5.3l12,21.6v0.4h-7.2L514.4,49.3z M502.5,43.8h10.3c3.3,0,6-0.9,8-2.6c2-1.7,3-4,3-6.9
		c0-3.2-0.9-5.6-2.8-7.2c-1.9-1.7-4.6-2.5-8.1-2.6h-10.3V43.8z"
                  />
                  <path
                    className="st1"
                    d="M575.1,56.6h-21.3L549,69.9h-6.9L561.5,19h5.9l19.5,50.9H580L575.1,56.6z M555.8,51.1h17.3l-8.7-23.8
		L555.8,51.1z"
                  />
                  <path
                    className="st1"
                    d="M607.6,50v19.9h-6.7V19h18.8c5.6,0,9.9,1.4,13.1,4.3c3.2,2.8,4.7,6.6,4.7,11.3c0,4.9-1.5,8.7-4.6,11.4
		c-3.1,2.7-7.5,4-13.3,4H607.6z M607.6,44.5h12.1c3.6,0,6.3-0.8,8.3-2.5c1.9-1.7,2.9-4.1,2.9-7.3c0-3-1-5.5-2.9-7.3
		c-1.9-1.8-4.5-2.8-7.9-2.8h-12.4V44.5z"
                  />
                  <path
                    className="st1"
                    d="M668.7,44.5L682,19h7.6l-17.5,31.9v19h-6.7v-19L647.8,19h7.7L668.7,44.5z"
                  />
                  <path
                    className="st1"
                    d="M373.3,142H349l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58h-7.8L373.3,142z M351.3,135.7H371l-9.9-27.1L351.3,135.7z"
                  />
                  <path
                    className="st1"
                    d="M444.9,138.8c-0.7,6.1-3,10.9-6.8,14.2c-3.8,3.3-8.9,5-15.2,5c-6.9,0-12.3-2.5-16.5-7.4
		c-4.1-4.9-6.2-11.5-6.2-19.7v-5.6c0-5.4,1-10.1,2.9-14.2c1.9-4.1,4.7-7.2,8.2-9.4c3.5-2.2,7.6-3.3,12.3-3.3
		c6.2,0,11.1,1.7,14.8,5.2c3.7,3.4,5.9,8.2,6.5,14.3h-7.7c-0.7-4.6-2.1-8-4.3-10.1c-2.2-2.1-5.3-3.1-9.3-3.1
		c-4.9,0-8.7,1.8-11.5,5.4c-2.8,3.6-4.2,8.8-4.2,15.4v5.6c0,6.3,1.3,11.3,3.9,15c2.6,3.7,6.3,5.6,11,5.6c4.2,0,7.5-1,9.8-2.9
		c2.3-1.9,3.8-5.3,4.5-10.1H444.9z"
                  />
                  <path
                    className="st1"
                    d="M495.5,142h-24.3l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58H501L495.5,142z M473.5,135.7h19.7l-9.9-27.1L473.5,135.7
		z"
                  />
                  <path
                    className="st1"
                    d="M524.9,157.2v-58h16.4c5,0,9.5,1.1,13.4,3.3c3.9,2.2,6.9,5.4,9,9.5c2.1,4.1,3.2,8.8,3.2,14.2v3.7
		c0,5.5-1.1,10.3-3.2,14.4c-2.1,4.1-5.1,7.3-9,9.5c-3.9,2.2-8.5,3.3-13.7,3.4H524.9z M532.5,105.4v45.5h8c5.9,0,10.5-1.8,13.8-5.5
		c3.3-3.7,4.9-8.9,4.9-15.7v-3.4c0-6.6-1.5-11.7-4.6-15.4c-3.1-3.7-7.5-5.5-13.2-5.6H532.5z"
                  />
                  <path
                    className="st1"
                    d="M619.3,130.4h-25.1v20.6h29.2v6.3h-36.9v-58H623v6.3h-28.8v18.7h25.1V130.4z"
                  />
                  <path
                    className="st1"
                    d="M650.9,99.2l19,47.3l19-47.3h9.9v58h-7.6v-22.6l0.7-24.4l-19,47H667l-19-46.9l0.8,24.3v22.6h-7.6v-58H650.9z"
                  />
                  <path
                    className="st1"
                    d="M737,128.3l15.1-29.1h8.7l-20,36.4v21.6h-7.6v-21.6l-20-36.4h8.8L737,128.3z"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>

        <p
          lang="en-GB"
          align="CENTER"
          style={{ marginBottom: "0.19in", textAlign: "center" }}
          className="text-header"
        >
          <font face="Lucida Sans, sans-serif">
            <font>
              <b>PRIVACY STATEMENT ("Privacy Statement")</b>
            </font>
          </font>
        </p>
        <p
          lang="en-GB"
          align="JUSTIFY"
          style={{ marginTop: "0.19in", marginBottom: "0.19in" }}
          className="text-header"
        >
          <font color="#000000">
            <font face="Lucida Sans, sans-serif">
              <font>
                <b>19/10/2018</b>
              </font>
            </font>
          </font>
        </p>

        <h5>1. WHAT IS A PRIVACY STATEMENT AND WHY IS IT IMPORTANT</h5>
        <p>
          We know your personal information is important to you and it is also
          important to Therapy Hub Limited (“TherapyAcademy”, “we”, “us”). This
          Privacy Statement tells you what we use your personal information for
          and explains your rights around how we use it. Please read this
          Privacy Statement to understand how and why we use your personal
          information. If you give us personal information about someone else,
          please make sure you have their permission and please make them aware
          of this Privacy Statement as it also applies to them.
        </p>

        <h5>2. WHO CONTROLS YOUR INFORMATION</h5>
        <p>
          For the purposes of the applicable data protection legislation,
          Therapy Hub Limited is the data controller. You will find our contact
          details in the “Contact us” section below
        </p>

        <h5>3. INFORMATION WE MAY COLLECT AND PROCESS</h5>
        <p>We may collect and process the following categories of data:</p>
        <h4>Information you give us:</h4>
        <ul>
          <li>Full name;</li>
          <li>Email address</li>
          <li>Profession</li>
          <li>Governing body membership information</li>
        </ul>

        <h4>Cookies</h4>
        <p>
          For more information on our use of cookies and beacons, please read
          our <Link to="/cookiespolicy">Cookies Policy</Link>. We may also
          process other information, which is not personal data within the
          meaning of data protection law.
        </p>

        <h5>4. WHY WE COLLECT AND PROCESS YOUR INFORMATION</h5>
        <p>
          Without collecting and using the information you provide to us or we
          obtain about you, it would not be possible for us to provide you with
          our services. We use information held about you in the following ways:
        </p>

        <h4>
          Information you give to us. <span>We will use this information:</span>
        </h4>
        <ol>
          <li>
            to carry out our obligations arising from any contracts entered into
            between you and us and to provide you with the information and
            services that you request from us;
          </li>
          <li>to remind you of your upcoming session;</li>
          <li>to keep you up-to-date on our service and new features;</li>
          <li>
            to provide you with information about new services we offer that are
            similar to those that you have already purchased or enquired about;
          </li>
          <li>
            to contact you from time to time for market research purposes. We
            may contact you by email, phone or mail.
          </li>
        </ol>

        <h4>
          Information we collect about you.{" "}
          <span>We will use this information:</span>
        </h4>

        <ol>
          <li>
            to administer our services and for internal operations, including
            troubleshooting, data analysis, testing, research, statistical and
            survey purposes;
          </li>
          <li>
            to improve our services to ensure that content is presented in the
            most effective manner for you and for your computer;
          </li>
          <li>as part of our efforts to keep our services safe and secure.</li>
        </ol>

        <p>
          We must have lawful bases to collect and use your personal
          information, the below sets these out:
        </p>

        <h4>
          Needed for your contract.{" "}
          <span>Personal information about you is held and used to:</span>
        </h4>
        <ol>
          <li>
            carry out our obligations arising from any contracts entered into
            between you and us;
          </li>
          <li>provide you with information about the service;</li>
          <li>receive payment;</li>
        </ol>

        <h4>
          Required by law:{" "}
          <span>
            We use your personal information to comply with law and regulations.
            For example:
          </span>
        </h4>

        <ol>
          <li>keeping proper books and records;</li>
          <li>audit purposes;</li>
          <li>
            to comply with any other legal obligations to which we are subject;
          </li>
        </ol>

        <h4>
          Our legitimate interest.{" "}
          <span>
            We use your personal information for our legitimate interests as
            shown below. We have taken account of any privacy risks and ensured
            that your data protection rights are not affected. We believe these
            uses benefit our customers. You can contact us if you have any
            questions using the contact details below.
          </span>
        </h4>

        <ol>
          <li>Managing and improving our services;</li>
          <li>
            Statistical Analysis: we combine and group personal information for
            analysis to help us understand our customers and develop better
            products and services;
          </li>
          <li>Prevention of fraud;</li>
          <li>Provision of customer care and service;</li>
        </ol>

        <p>
          With your consent from time to time we would like to contact you to:
        </p>

        <ol>
          <li>invite you to events we are organising;</li>
          <li>
            provide you with information on products or services which we feel
            may interest you;
          </li>
          <li>
            gauge satisfaction with the products and/ or services you received
            from us.
          </li>
        </ol>

        <h5>5. WHO WE SHARE YOUR PERSONAL INFORMATION WITH</h5>
        <p>Governmental, Regulatory, etc.</p>

        <p>
          We may disclose your personal information to a governmental or
          regulatory body (including tax authorities, law enforcement agencies
          and financial regulators) in order to comply with a legal obligation
          or to any person pursuant to an order of a court or tribunal.
        </p>

        <h4>Professional Advisors and Experts</h4>
        <p>
          We may also disclose your information to our solicitors, auditors,
          insurance advisors and financial services advisors.
        </p>

        <p>
          We may share your information with selected third parties including:
        </p>
        <ol>
          <li>
            Business partners, suppliers and sub-contractors for the performance
            of any contract we enter into with them or you.
          </li>
          <li>
            Analytics and search engine providers that assist us in the
            improvement and optimisation of our products or services.
          </li>
        </ol>

        <p>We may disclose your personal information to third parties:</p>
        <ol>
          <li>
            In the event that we sell or buy any business or assets, in which
            case we may disclose your personal data to the prospective seller or
            buyer of such business or assets.
          </li>
          <li>
            If TherapyHub or substantially all of its assets are acquired by a
            third party, in which case personal data held by it about its
            customers will be one of the transferred assets.
          </li>
          <li>
            If we are under a duty to disclose or share your personal data in
            order to comply with any legal obligation and agreements; or to
            protect the rights, property, or safety of TherapyHub, its
            customers, or others.
          </li>
        </ol>

        <h5>6. DATA RETENTION PERIODS</h5>
        <p>
          The period for which we retain information varies according to the use
          of that information. In some cases, there are legal requirements to
          keep data for a minimum period of time. Unless specific legal
          requirements dictate otherwise, we will retain information no longer
          than is necessary for the purposes for which the data were collected
          and processed.
        </p>

        <p>
          Unless otherwise required under applicable law, we store your
          information for as long as we provide services to you and for a period
          of no less than 7 years after their termination or for as long as is
          necessary and permissible in accordance with statutory limitation
          periods.
        </p>

        <h5>7. SECURITY</h5>
        <p>
          We are committed to protecting the security of your personal data. We
          use a variety of security technologies and procedures to help protect
          your personal data from unauthorised access and use.
        </p>

        <p>
          As effective as modern security practices are, no physical or
          electronic security system is entirely secure. The transmission of
          information via the internet is also not completely secure. We cannot
          guarantee the complete security of our databases, nor can we guarantee
          that information you supply will not be intercepted while being
          transmitted to us over the internet. We will continue to revise
          policies and implement additional security features as new
          technologies become available.
        </p>

        <p>
          Although we will do our best to protect your personal data, we cannot
          guarantee the security of your personal data transmitted to us. Any
          transmission of data is at your own risk. Once we receive your
          personal data, we use appropriate security measures to seek to prevent
          unauthorised access.
        </p>

        <h5>
          8. TRANSFERS OF YOUR INFORMATION OUTSIDE OF THE EUROPEAN ECONOMIC AREA
        </h5>
        <p>
          We do not transfer any Personal Data outside of the EEA. However,
          certain third parties providing services to us may transfer data
          outside of the EEA for example, for storage or IT support purposes.
        </p>
        <p>
          Any transfer of personal data outside of the EEA would only be made
          through transfer mechanisms approved or allowed for under Data
          Protection Law and we take care to ensure that there is adequate
          protection, as required by Data Protection Law.
        </p>

        <h5>YOUR RIGHTS</h5>
        <p>
          As an individual, under EU law you have the right to request that we:
        </p>

        <ol>
          <li>
            provide you with information as to whether we process your data and
            details relating to our processing, and that we provide you with a
            copy of your data (‘access right’).
          </li>
          <li>
            rectify and/ or update any inaccurate data we might have about your
            without undue delay (‘right to rectification’).;
          </li>
          <li>
            the right to object to processing of data relating to you (‘right to
            object’).
          </li>
          <li>
            under certain circumstances, be restricted from processing your data
            (‘right to restriction’).
          </li>
          <li>
            under certain circumstances, erase your personal data without undue
            delay (i.e. the “right to erasure”). and
          </li>
          <li>
            under certain circumstances, furnish you with the personal data
            which you provided us with in a structured, commonly used and
            machine readable format (‘right to data portability’).
          </li>
        </ol>

        <p>
          Where we process your data solely on the basis of your consent, you
          are entitled to withdraw your consent at any time. This will not
          affect the lawfulness of our processing before the withdrawal.
        </p>

        <p>
          You also have the right to lodge a complaint with the Data Protection
          Commission at any time.
        </p>

        <p>
          The exercise of your rights might be subject to certain conditions and
          we might require further information from you before we can respond to
          your request.
        </p>
        <p>
          You may exercise your rights by contacting our Data Protection
          Champion at the address or e-mail address provided below.
        </p>

        <h5>9. CHANGES TO THIS STATEMENT</h5>

        <p>
          We reserve the right to change this Statement from time to time in our
          sole discretion. If we make any changes, we will publish those changes
          on our website. At the bottom of this document you will find the date
          on which this Statement was last updated.
        </p>

        <h5>10. CONTACT US</h5>

        <p>
          Questions, comments, requests and complaints regarding this Statement
          and the information we hold are welcome and should be addressed to us
          at <a href="mailto:michael@therapyhub.ie">michael@therapyhub.ie</a>.
          We endeavour to deal with all requests promptly and efficiently.
        </p>

        <p>
          Data Protection Champion:
          <br /> <b>Michael O’Carroll</b>,{" "}
          <a href="mailto:michael@therapyhub.ie">michael@therapyhub.ie</a>, 087
          3356536
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/PrivacyPolicy.jsx